const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHemostasis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E92E30",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M23.926,20.633 c0,4.318-3.5,7.818-7.818,7.818s-7.818-3.5-7.818-7.818c0-4.319,7.238-17.21,7.818-17.21C16.479,3.422,23.926,16.314,23.926,20.633 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C70F0D"
    },
    d: "M17.466,25.655c-4.099,0-7.421-3.323-7.421-7.421c0-2.851,3.325-9.638,5.534-13.505 C13.9,7.117,8.633,16.943,8.633,20.532c0,4.098,3.321,7.419,7.419,7.419c3.154,0,5.852-1.972,6.925-4.748 C21.618,24.708,19.651,25.655,17.466,25.655z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M8.346,17.957c0,0-3.701-1.302-1.732-3.076 c0,0,1.985-1.779,5.791-0.289c0,0,2.4,1.044,3.641,1.727c0,0,3.166,2.048,5.678,0.527"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.673,13.227c0,0,3.228-3.098,7.634-2.937 c0,0,4.156-0.063,4.176,1.82c0,0,0.104,2.145-4.656,2.308"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M22.174,8.966c0,0,5.35-0.542,6.67,1.598 c0,0,0.543,0.884-0.172,1.986"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M7.939,20.154c0,0-3.933,0.871-3.146,2.422 c0,0,0.827,1.594,5.232,1.139c0,0,3.724-0.539,6.309-2.938"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M4.916,24.086c0,0,3.537,2.359,9.102-0.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2C355E"
    },
    points: "17.209,13.667 15.219,13.661 15.223,11.572  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2C355E"
    },
    points: "15.271,19.969 17.254,20.148 17.066,22.229  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHemostasis);
export default __webpack_public_path__ + "static/media/hemostasis.f31d271cb812a89247b890e9771b1d16.svg";
export { ForwardRef as ReactComponent };